import { QuoteItemCoveragesSearchResponse } from '@lio/api-types';

import { GroupedQuote } from '@lio/rule-engine/utils/quote-details';
import { getEngine } from '@lio/rule-engine';
import { formatCurrency } from '@utils/number';
import { StructuredQuote } from '@store/Quote/Quote.types';

type QuoteItemCoverage = QuoteItemCoveragesSearchResponse['items'][number];

export const getPremiumRows = (quoteItemCoverages: QuoteItemCoverage[], structuredQuote: StructuredQuote) => {
  const ruleEngine = getEngine(structuredQuote as GroupedQuote);

  const premiumsToCheck = [
    {
      name: 'General Liability Premium',
      codeName: 'LOIGeneralLiabilityInd',
    },
    {
      name: 'Inland Marine Premium',
      codeName: 'LOIInlandMarineInd',
    },
    {
      name: 'Sexual Abuse Or Sexual Molestation Premium',
      codeName: 'LOISexualAbuseMolestationInd',
    },
    {
      name: 'Excess Premium',
      codeName: 'LOIExcessLiabilityInd',
    },
    {
      name: 'Policy Premium',
    },
    {
      name: 'Policy Terrorism',
      codeName: 'PolicyTerrorismCoverageInd',
    },
  ];

  const premiumRows: {
    id: string;
    title: string;
    value: string;
  }[] = [];

  const policyQuoteItem = structuredQuote.quoteItems.find((qi) => qi.quoteItemType.codeName === 'Policy');
  if (!policyQuoteItem) {
    return [];
  }

  const attributes = policyQuoteItem?.attributeTypes ?? {};
  ruleEngine.setEngineInitialQuoteItem(policyQuoteItem.id);

  premiumsToCheck.forEach((item) => {
    const rowName = item.name;
    const indicator = item.codeName ? attributes[item.codeName] : null;
    const isActive = indicator ? ruleEngine.execute(indicator.isActive) : true;
    if (!isActive) {
      return;
    }
    const coverage = quoteItemCoverages.find((qicr) => qicr.coverage.coverageName === rowName);

    if (coverage) {
      const termPremiumItem = coverage.quoteItemCoverageAttributes.find(
        (attr) => attr.coverageAttributeType.coverageAttributeCategory === 'TermPremium',
      );

      const termPremium = termPremiumItem?.value;

      let title = rowName;

      if (rowName === 'Policy Premium') {
        title = 'Total Premium';
      } else if (rowName === 'Policy Terrorism') {
        title = 'Terrorism (included in above total premium)';
      }

      premiumRows.push({
        id: `${coverage.id}-premium`,
        title,
        value: formatCurrency(termPremium as string),
      });
    }
  });

  return premiumRows;
};
